export const IP_LOOKUP_ACCESS_TOKEN = "083c694c79f119c7f227e737de9a5c8c";
export const IP_LOOKUP_STORAGE_KEY = "IP_LOOKUP_DETAILS_STORAGE";
export const MAX_CACHE_AGE = 60 * 60 * 1000;
